import { get } from '..';
import { HappyScoreCategory, NotificationType } from '../../constants/Types';

const getInsightNotifications = (
  locationId: string,
  category: HappyScoreCategory | null = null,
  startDate: string | null = null,
  endDate: string | null = null,
) => {
  let endpoint = `button/v2/notifications?locationId=${locationId}`;
  endpoint += `&type=${NotificationType.ALERT}`;
  endpoint += `&type=${NotificationType.INSIGHT}`;
  endpoint += `&type=${NotificationType.ANOMALY}`;
  if (category) endpoint += `&notificationCategory=${category}`;
  if (startDate) {
    // requestUrl += `&startdatetime=${startDate.toString()}`;
  }
  if (endDate) {
    // requestUrl += `&enddatetime=${endDate.toString()}`;
  }
  return get(endpoint);
};

export default getInsightNotifications;
